<template>

      <div class="container ">

        <div class="wrap">

            <transition name="fade">
                <h3 class="entry-title" v-if="showThanks"> <i class="fas fa-check"></i> Dziękujemy za Podpisanie umowy, poinformujemy Cię o wypłacie pożyczki e-mailem oraz sms. </h3>
            </transition>


            <transition name="slide-fade" @after-leave="signDone">
                <h3 class="entry-title" v-if="!isSigned"> <i class="fas fa-file-signature"></i> Poniżej znajduje się Twoja Umowa pożyczki w kwocie {{ this.loanAmount }} zł,
                 zapoznaj się z nią i podpisz, a gotówka trafi na Twoje konto bankowe.  </h3>
            </transition>

            <p class="col-10 mx-auto yellow-card"><strong>Po podpisaniu umowy nasze Biuro Obsługi Klienta może jeszcze skontaktować się z Tobą celem weryfikacji danych.  <br><br>        
Po pozytywnej decyzji pożyczka zostanie natychmiastowo przekazana na Twój rachunek bankowy, a potwierdzenie otrzymasza za pomocą wiadomości sms i email. 
</strong></p>


          <!--<div class="col-12 mx-auto" style="width: 75%;">
            <iframe height="600px" width="100%"  src="#/pdf"></iframe>
          </div>-->
          <div style="width:100%; align-content: center; text-align: center;">
            <b-row>
              <b-col md="4" cols="8" class="thankYouBoxPDF mx-auto">

                <a :href="pdfSource" download="Umowa" class="downloadLink">

                <b-row>

                  <b-col class="obrazekPDFdoPobrania " md="3" cols="1">
                    <i class="fas fa-file-download" style="color: #fd7e14;"></i>
                  </b-col>

                  <b-col md="9" cols="10" class="downloadPdfText">
                      <span class="littleBitBiggerText">Umowa pożyczki 30 dni {{ this.loanAmount }} zł</span> <br>
                      kliknij aby <strong> Otworzyć umowę </strong>
                  </b-col>
                </b-row>
                </a>
              </b-col>
            </b-row>
          </div>


          <SignContract v-if="showSignature"  label="Podpisz Umowę" @signed="signedTerms"/>


        </div>

            
          <div class="modal fade" ref="modalThankYouDialog" id="thankYouDialog" >
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header dark-bg">
                  <div class="col-auto me-auto ">
                    <h3>Umowa podpisana.</h3>
                  </div>
                  <div class="col-auto d-flex align-items-center">
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                </div>
                <div class="form-control">
                  <form>
                    <div style="font-size: 20px; color: #045439; padding: 20px;">
                      Dziękujemy.
                      Umowa została pomyślnie podpisana.
                    </div>
                  </form>
                </div>
                <div class="modal-footer d-flex justify-content-around">
                  <form>
                    <b-col lg="4" class="pb-2">
                      <a class="form-button btn btn-outline-primary btn-lg me-2 login" data-bs-dismiss="modal" @click="gotomain">Powrót</a>
                    </b-col>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

</template>

<script>

    import SignContract from '@/components/SignContract';
    

    export default {
     
       name: 'MCThankYouView',


       components: { SignContract },

       data(){

            return {

                isSigned: false,

                showThanks: false,

                showSignature: true,

                modal:null,
            }
       },

       computed: {
         pdfSource(){
           return this.getConf('secondaryEndpoint') + '/application/agreement';
         }
       },

       methods: {

        signDone(){


            this.showThanks = true;

        },


        signedTerms(){


            this.signTerms();


            setTimeout(() => {

                this.showSignature = false;
            }, 900);


        },


        signTerms() {

           var page = this.$root.mainpage,
               loanId = page.loanId;

            if (!loanId) {

                this.post('/accept')
                  .then(response => {


                    if (!!response.data) {

                      let ok = !(response.data.IS_ERROR | 0);


                      if (ok) {

                          this.echo('thank_you_modal');

                        this.isSigned = true;
                      }

                      //console.log('acccepted  ')

                    }
                  })
                  .catch(error => {

                               // Error
                      if (error.response) {
                         console.log(error.response);
                      }
                  });
              }
              else {

                // reset
                page.loanId = null;


                this.patch( '/accept', {
                    loan_id: loanId 
                  })
                      .then(response => {


                        if (!!response.data) {

                          let ok = !(response.data.IS_ERROR | 0);

                          this.echo('thank_you_modal');

                            this.isSigned = true;

                        }
                      })
                      .catch(error => {

                                   // Error
                          if (error.response) {

                            console.log(error.response);

                          }
                      });
              }

        },


        gotomain(){

            this.$router.push({path: '/'});
        }
       },




       mounted(){

            this.modal = new bootstrap.Modal(this.$refs['modalThankYouDialog']);

            // scroll to top with .5s delay
            this.pageTop();

       }



        
    }
</script>

<style scoped>


<style scoped>
  @media(max-width: 481px){
    .fas{
      margin-bottom: 10px;
      margin-top: 0;
      font-size:20px;
      margin-left:10px;
    }
    .downloadPdfText{
      padding: 0;
      margin-bottom: 10px;
      margin-top: 0;
      margin-left:10px;

    }
    .thankYouBoxPDF{
      padding: 0;
    }
  }
  @media(min-width: 1px){
    .fas{
      margin-top: 11px;
      margin-left:14px;
      font-size:17px;
    }
    .downloadPdfText{
      padding: 0;

    }
  }
  @media(min-width: 481px){
    .fas{
      margin-top: 12px;
      margin-left:13px;
      font-size:17px;
    }
    .downloadPdfText{
      padding: 0;

    }
  }
  @media (min-width: 768px) {
    .fas{
      font-size:45px;
      margin-bottom: 10px;
      margin-top: 10px;

    }
  }
  .obrazekPDFdoPobrania{
    padding: 0;
  }
  .thankYouBoxPDF{
    background-color: #e5e5e5;
    border-radius:.5rem;
    border: 2px solid #bbb;
    padding: 0;
  }
  .downloadPdfText{
    text-align: left;
    justify-content: left;
    padding: 0;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .downloadLink{
    color: #464646;
    text-decoration: none;
  }
  .thankYouBoxPDF:hover{
    border: 2px solid #ffb401;
  }


h3 i {
    color: #fd7e14;
}


.entry-title {


    font-size:32px;
    margin: 2.8em 0 2em;

    text-align: center;

}


.form-btn-wrap {

  margin-top: .5rem;
  padding: 2rem 1rem;

  display: flex;
  justify-content:center;
}

.button {

    cursor:pointer;
    min-width:260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px;
    border:0px;

    margin: 0 .5rem;

}

.button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}






.fade-enter-active,.fade-leave-active {
  transition: opacity 3s
}
.fade-enter,.fade-leave-active {
  opacity: 0
}


.slide-fade-enter-active {
  transition: all .5s ease;
}

.slide-fade-leave-active {
  transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,.slide-fade-leave-active {
  padding-left: 10px;
  opacity: 0;
}

</style>


// WEBPACK FOOTER //
// src/MCThankYouView.vue